class InfiniteLoad extends HTMLElement {
  constructor () {
    super()
    this.location = window.location
    this.urlParams = new URLSearchParams(this.location.search)
    this.prevUrl = this.dataset.prevUrl
    this.nextUrl = this.dataset.nextUrl
    this.currentPage = this.dataset.currentPage
    this.currentUrl = ''
    this.nextPaginatedSet = ''
    this.elementsContainer = document.querySelector(this.dataset.containerSelector)
    this.paginateElements = this.querySelectorAll(this.dataset.elementsSelector)
    this.previousY = 0
    this.previousRatio = 0
    this.footerViewed = false
    this.triggerButton = this.querySelector('button')
    this.loadingIndicator = this.querySelector('span')
    this.renderContainer.bind(this)
    this.renderNewNavigation.bind(this)
    this.maintainPosition = false
  }

  connectedCallback () {
    const footerObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.footerViewed = true
          observer.disconnect();
        }
      });
    }, { threshold: 0 });
    const footer = document.querySelector('footer');
    footerObserver.observe(footer);

    this.urlParams.set('page', this.currentPage)
    this.currentUrl = `${window.location.pathname}?${this.urlParams}`

    if (this.currentPage > 1 && this.maintainPosition) {
      history.replaceState(null, "", this.currentUrl);
    }

    this.fetchItems(this.nextUrl);

    //this.triggerButton.addEventListener('click', this.loadNextPage.bind(this));

    setTimeout(() => {
      this.observer = new IntersectionObserver(this.observerCallback.bind(this), {
        threshold: 0
      });

      this.observer.observe(this);
    }, 3000)
  }

  observerCallback(entries, observer) {
    entries.forEach(entry => {
      let currentY = entry.boundingClientRect.y
      let currentRatio = entry.intersectionRatio

      if (currentY < this.previousY || this.footerViewed) {
        if (!this.nextUrl) {
          this.loadingIndicator.style.display = 'none';
          return;
        }
        this.footerViewed = false;
        this.loadNextPage();
      }
      this.previousY = currentY
      this.previousRatio = currentRatio
    });
  }

  loadNextPage() {
    this.loadingIndicator.style.display = 'block';
    this.renderContainer(this.nextPaginatedSet)
    this.renderNewNavigation(this.nextPaginatedSet)

    this.urlParams.set('page', this.currentPage)
    this.currentUrl = `${window.location.pathname}?${this.urlParams}`

    if (this.maintainPosition) history.replaceState(null, "", this.currentUrl);
    // this.loadingIndicator.style.display = 'none';
  }

  fetchItems(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        this.nextPaginatedSet = responseText;
      })
  }

  renderContainer(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').querySelector(this.dataset.containerSelector).innerHTML;
    this.elementsContainer.innerHTML = this.elementsContainer.innerHTML + newPage;
  }

  renderNewNavigation(html) {
    this.currentPage = new DOMParser().parseFromString(html, 'text/html').querySelector('infinite-load').dataset.currentPage
    this.prevUrl = new DOMParser().parseFromString(html, 'text/html').querySelector('infinite-load').dataset.prevUrl
    this.nextUrl = new DOMParser().parseFromString(html, 'text/html').querySelector('infinite-load').dataset.nextUrl

    this.dataset.currentPage = this.currentPage
    this.dataset.prevUrl = this.prevUrl ? this.prevUrl : ''
    this.dataset.nextUrl = this.nextUrl ? this.nextUrl : ''

    if (!!this.nextUrl) {
      this.fetchItems(this.nextUrl)
    }
  }
}

class PaginationWrapper extends HTMLElement {
  constructor() {
    super()
    this.location = window.location
    this.urlParams = new URLSearchParams(this.location.search)
    this.prevUrl = this.dataset.prevUrl;
    this.prevPage = this.dataset.currentPage
    this.currentUrl = ''
    this.elementsContainer = document.querySelector(this.dataset.containerSelector);
    this.prevPagination = ''
  }

  connectedCallback() {
    this.urlParams.set('page', this.prevPage)
    this.currentUrl = `${window.location.pathname}?${this.urlParams}`

    this.addEventListener('click', e => {
      e.preventDefault()

      this.fetchItems(this.dataset.prevUrl)
    })
  }

  fetchItems(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        this.renderContainer(responseText)
        this.renderNewNavigation(responseText)

        if (this.maintainPosition) history.replaceState(null, "", this.currentUrl);
      })
  }

  renderContainer(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').querySelector(this.dataset.containerSelector).innerHTML;
    this.elementsContainer.innerHTML = newPage + this.elementsContainer.innerHTML
  }

  renderNewNavigation(html) {
    this.prevPagination = new DOMParser().parseFromString(html, 'text/html').querySelector('pagination-wrapper')

    if (this.prevPagination) {
      this.dataset.prevUrl = this.prevPagination.dataset.prevUrl
      this.dataset.currentPage = this.prevPagination.dataset.currentPage

      this.prevPage = this.dataset.currentPage
      this.urlParams.set('page', this.prevPage)
      this.currentUrl = `${window.location.pathname}?${this.urlParams}`

      this.innerHTML = this.prevPagination.innerHTML
    } else {
      this.urlParams.delete('page')
      this.currentUrl = `${window.location.pathname}?${this.urlParams}`
      if (this.maintainPosition) history.replaceState(null, "", this.currentUrl);
      this.remove()
    }
  }
}

customElements.define('infinite-load', InfiniteLoad)
customElements.define('pagination-wrapper', PaginationWrapper)
